package com.xtream.data_kmp.dto



import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class ServerConfig(
    @SerialName("server_url")
    val serverUrl: String?,
    @SerialName("account_server")
    val accountServerUrl: String?,
    @SerialName("tmdb_key")
    val tmdbKey: String?,
    @SerialName("user_agent")
    val userAgent: String?,
    @SerialName("xor_key")
    val xorKey: String?,

    @SerialName("server_name")
    val serverName: String?=null,
    @SerialName("subtitle_api_key")
    val subtitleKey: String?=null,
    @SerialName("subtitle_api_url")
    val subtitleServer: String?=null,
    @SerialName("accent_color")
    val accentColor: String?=null,
    @SerialName("analytics_url")
    val analyticsUrl: String?=null,
    @SerialName("backup_servers")
    val backupServers: List<BackupServer?>?=null,
    @SerialName("banner")
    val banner: String?=null,
    @SerialName("billboard_url")
    val billboardUrl: String?=null,
    @SerialName("cdn_url")
    val cdnUrl: String?=null,
    @SerialName("created_at")
    val createdAt: String?=null,
    @SerialName("features")
    val features: Features?=null,
    @SerialName("heartbeat_interval")
    val heartbeatInterval: Int?=null,
    @SerialName("id")
    val id: Int?=null,
    @SerialName("logo_url")
    val logoUrl: String?=null,
    @SerialName("message")
    val message: String?=null,
    @SerialName("msg_title")
    val msgTitle: String?=null,
    @SerialName("panorama_url")
    val panoramaUrl: String?=null,
    @SerialName("primary_color")
    val primaryColor: String?=null,

    @SerialName("show_message")
    val showMessage: Boolean?=null,
    @SerialName("status")
    val status: Boolean?=null,
    @SerialName("theme")
    val theme: String?=null,

    @SerialName("trial_password")
    val trialPassword: String?=null,
    @SerialName("trial_username")
    val trialUsername: String?=null,
    @SerialName("update_required")
    val updateRequired: Boolean?=null,
    @SerialName("updated_at")
    val updatedAt: String?=null,


    @SerialName("version")
    val version: String?=null,
) {
    
    @Serializable
    data class BackupServer(
        @SerialName("url")
        val url: String?
    )

    
    @Serializable
    data class Features(
        @SerialName("downloads")
        val downloads: Boolean?,
        @SerialName("live_tv")
        val liveTv: Boolean?,
        @SerialName("offline_mode")
        val offlineMode: Boolean?
    )
}